import React from 'react';
import {Route, Routes} from "react-router-dom";
import Layout from "./Layout";
import Main from "../page/Main";
import Hub from "../page/Hub";
import Explorer from "../page/Explorer";
import Docs from "../page/Docs";

function RootRouter(props) {
  return (
      <Routes>
        <Route path="/*" element={<Layout/>}>
          <Route index element={<Main/>}/>
          <Route path='hub' element={<Hub/>}/>
          <Route path='explorer' element={<Explorer/>}/>
          <Route path='docs' element={<Docs/>}/>
        </Route>
      </Routes>
  );
}

export default RootRouter;